import { render } from "./ImageMap.vue?vue&type=template&id=eff179ec&scoped=true"
import script from "./ImageMap.vue?vue&type=script&lang=js"
export * from "./ImageMap.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-eff179ec"

export default script